import { z } from '@exodus/zod'
import { memoize } from '@exodus/basic-utils'

const createAbTestingReport = ({ abTestingAtom, abTestingLoadedAtom }) => ({
  namespace: 'abTesting',
  export: async ({ walletExists } = Object.create(null)) => {
    if (!walletExists) return null

    const [abTesting, loaded] = await Promise.all([abTestingAtom.get(), abTestingLoadedAtom.get()])

    return {
      loading: !loaded,
      experiments: abTesting.experiments,
    }
  },
  getSchema: memoize(() =>
    z
      .object({
        experiments: z.record(z.string(), z.record(z.string(), z.boolean())).optional(),
        loading: z.boolean(),
      })
      .nullable()
  ),
})

const abTestingReportDefinition = {
  id: 'abTestingReport',
  type: 'report',
  factory: createAbTestingReport,
  dependencies: ['abTestingAtom', 'abTestingLoadedAtom'],
  public: true,
}

export default abTestingReportDefinition
